/** @format */

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /* Remove empty <p> tags created by tinymce*/
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  /*tabs sections*/
  const tabLinks = document.querySelectorAll(".js-tabs-menu a");

  for (let i = 0; i < tabLinks.length; i++) {
    tabLinks[i].onclick = function () {
      let target = this.getAttribute("href").replace("#", "");
      let sections = document.querySelectorAll("div.tab-content");
      for (let j = 0; j < sections.length; j++) {
        sections[j].style.display = "none";
      }
      document.getElementById(target).style.display = "block";
      for (let k = 0; k < tabLinks.length; k++) {
        tabLinks[k].classList.remove("active");
      }
      this.classList.add("active");
      return false;
    };
  }

  const intro_content = document.querySelector(".top-content-home");
  const intro_copy = document.querySelector(".intro-copy");

  if (intro_content) {
    document
      .getElementsByClassName("top-content-home")[0]
      .classList.add("appear");
  }

  if (intro_copy) {
    document.getElementsByClassName("intro-copy")[0].classList.add("appear");
  }

  const animateHTML = function () {
    let elems, elemsShow, windowHeight;
    let init = function () {
      elems = document.getElementsByClassName("hide-object");
      elemsShow = document.getElementsByClassName("show-object");
      windowHeight = window.innerHeight;
      addEventHandlers();
    };
    let addEventHandlers = function () {
      window.addEventListener("scroll", checkPosition);
      window.addEventListener("resize", init);
    };
    let checkPosition = function () {
      for (let i = 0; i < elems.length; i++) {
        let posFromTop = elems[i].getBoundingClientRect().top;
        if (posFromTop - windowHeight <= 0) {
          elems[i].className = elems[i].className.replace(
            "hide-object",
            "show-object"
          );
        }
      }
      for (let i = 0; i < elemsShow.length; i++) {
        let posFromTop = elemsShow[i].getBoundingClientRect().top;
        if (posFromTop - windowHeight >= 0) {
          elemsShow[i].className = elemsShow[i].className.replace(
            "show-object",
            "hide-object"
          );
        }
      }
    };
    return {
      init: init,
    };
  };
  animateHTML().init();

  /*docking widget

  
  // const fulldocking = document.querySelector(".header__docking-holder");
  // const dockingWidget = {
  //   dockingOpen: document.querySelector(".docking-trig-js"),
  //   dockingClose: document.querySelector(".close-docking-js"),
  // };

  if (fulldocking) {
    dockingWidget.dockingOpen.addEventListener("click", function () {
      fulldocking.classList.add("expanded");
    });
    dockingWidget.dockingClose.addEventListener("click", function () {
      fulldocking.classList.remove("expanded");
    });
  }

    $("select").select2();*/

  $("select.bookinglink").on("change", function () {
    $(this).next(".book-now").attr("href", this.value);
    $(this).siblings(".error").remove();
  });
  $(".room-options .book-now").click(function (e) {
    if ($(this).attr("href") == "") {
      e.preventDefault();
      $(this).after(
        "<span class='error' style='color:#f00;display:block;padding:10px 0;'>Please Select Bed Type</span>"
      );
    }
  });

  $(".footer__email-signup .btn").click(function () {
    var $this = $(this);
    $(".footer__form-holder").slideToggle();

    $this.toggleClass("expanded");

    if ($this.hasClass("expanded")) {
      $this.html('Close<span class="mask-copy">Close</span>');
    } else {
      $this.html('Sign Up<span class="mask-copy">Sign Up</span>');
    }
  });

  $(".sorting ul li a").click(function (e) {
    e.preventDefault();
    var selectedTab = $(this).attr("data-tab");
    if (selectedTab == "all") {
      $(".each-special").show();
    } else {
      $(".each-special")
        .not(".each-special." + selectedTab)
        .hide();
      $("." + selectedTab).show();
      if (!$("." + selectedTab + " > div").hasClass("fade-in")) {
        $("." + selectedTab + " > div").addClass("visible fade-in");
      }
    }
    $(".sorting ul li a").removeClass("active");
    $(this).addClass("active");
  });

  $(".fancybox-pdf").fancybox({
    openEffect: "elastic",
    closeEffect: "elastic",
    autoSize: true,
    type: "iframe",
    iframe: {
      preload: false, /* fixes issue with iframe and IE */
    },
  });

  /*** start of list navigation ***/
  jQuery(document).ready(function ($) {
    $(".sticky-navigation ul a[href*=\\#]:not([href=\\#])").click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") ||
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top - 200,
            },
            1000
          );
          return false;
        }
      }
    });
  });

  /* Fixed Nav */
  jQuery(document).ready(function ($) {
    $(window).scroll(function () {
      var scrollTop =
        $(".top-content").height() +
        $(".intro-copy").height() +
        ($(".social-restaurants").height() + 30) +
        144;
      var headerTop = $(".header").height();

      if ($(window).scrollTop() >= scrollTop) {
        $(".sticky-navigation").css({
          position: "fixed",
          top: headerTop,
        });
      }
      if ($(window).scrollTop() < scrollTop) {
        $(".sticky-navigation").removeAttr("style");
      }
    });
    /* Active Nav Link */
    $(".sticky-navigation li a").click(function () {
      $(".sticky-navigation li a").removeClass("active");
      $(this).addClass("active");
    });
  });

  function setActiveListElements(event) {
    /* Get the offset of the window from the top of page */
    var windowPos = $(window).scrollTop();

    $('.sticky-navigation li a[href^="#"]').each(function () {
      var anchorId = $(this);
      var target = $(anchorId.attr("href"));

      if (target.length > 0) {
        if (
          target.position().top - ($(".header").outerHeight() + 80) <=
          windowPos
        ) {
          $(".sticky-navigation li a").removeClass("active");
          anchorId.addClass("active");
        }
      }
    });
  }

  $(window).scroll(function () {
    setActiveListElements();
  });
  /*** end of list navigation ***/

  $(".sym-slides").slick({
    accessibility: false,
  });

  $(".sym-sliderrr").slick({
    accessibility: false,
  });

  $(".specials-slides").slick({
    arrows: false,
    dots: true,
    autoPlay: false,
    accessibility: false,
    fade: true,
  });

  $(".slider__homepage").slick({
    accessibility: true,
  });

  /*const requiredFormInput = document.querySelector("#form_id-1054-yes-signup-formemail-signup");
  if (requiredFormInput) {
    requiredFormInput.classList.add("required");
  }*/

  document.addEventListener('DOMContentLoaded', (event) => {
    
    let form_socialClub = document.getElementById('form_id-2984');

    if(form_socialClub){
      form_socialClub.querySelector('input[name="subscribe"][type="checkbox"]').classList.add('required');
    }

  });

   //for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs option').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs option').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	let selectMenu = document.querySelector('.menu-restaurant__tabs')
	selectMenu && selectMenu.addEventListener('change', (e) => {
		let menuId = selectMenu.value;

		let menu_container = document.querySelectorAll('.menu__unitmenu');
		menu_container = [...menu_container];

		menu_container.forEach( (contendor) => {
			if (contendor.dataset.tag == menuId) {
				contendor.classList.add('active');
			}else{
				contendor.classList.remove('active');
			}
		})

	})

})();

/** ADA Function to modify Menu **/

document.addEventListener('DOMContentLoaded', () => {
	const skipSelectors = [
		'.privary-navigation__item a',
		'.secondary-navigation__item a',
    '.social-media a'
	];


	skipSelectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		if (elements.length > 0) {
			elements.forEach(element => {
				element.setAttribute('tabindex', '-1');
			});
		}
	});
});

/** ADA Tab Links Functionality for Keyboard Navigation **/

document.addEventListener('DOMContentLoaded', () => {
  const navigation = document.querySelector('.header__nav-holder');
  const closeMenuButton = document.querySelector('.close-btn-js');
  const menuElements = [...document.querySelectorAll('#primary-nav .privary-navigation__item a, #secondary-nav .secondary-navigation__item a, .social-media a')];
  const bookingForm = document.querySelector('.header__booking-holder');    
  const formElements = [
    '#CheckIn', '#CheckOut', '#adults', '#child',
    '.header__booking-holder .submit button',
    '.header__booking-holder--phone', 
    '.header__booking-holder--notice a',
    '.header__booking-holder .header__logo',
    '.header__nav-holder .header__logo'
  ].map(selector => document.querySelector(selector));

  function setTabIndex(elements, value) {
    elements.filter(el => el).forEach(el => el.setAttribute('tabindex', value));
  }

  function handleFocusIn() {
    const isBookingExpanded = bookingForm.classList.contains('expanded');
    const isNavExpanded = navigation.classList.contains('expanded');
    
    setTabIndex(menuElements, isNavExpanded ? '0' : '-1');
    setTabIndex(formElements, isBookingExpanded ? '0' : '-1');
  }

  setTabIndex(menuElements, '-1');
  setTabIndex(formElements, '-1');

  if (closeMenuButton) {
    closeMenuButton.addEventListener('click', () => {
      navigation.classList.remove('expanded');
      handleFocusIn();
    });
  }

  document.querySelector('.header__nav-holder--close').addEventListener('click', () => {
    bookingForm.classList.add('expanded');
    handleFocusIn();
  });

  document.querySelector('.close-booking-js').addEventListener('click', () => {
    bookingForm.classList.remove('expanded');
    handleFocusIn();
  });

  document.addEventListener('focusin', handleFocusIn);
});

/** ADA Sets tabindex to -1 for all form elements **/

document.addEventListener('DOMContentLoaded', () => {
  const formElements = [
    document.querySelector('#id_0_1139'),
    document.querySelector('#id_1_1139'),
    document.querySelector('#id_2_1139'),
    document.querySelector('#id_3_1139'),
    document.querySelector('#id_4_1139'),
    document.querySelector('#id_5_1139'),
    document.querySelector('#id_6_1139'),
    document.querySelector('#id_7_1139'),
    document.querySelector('#id_8_1139'),
    document.querySelector('#id_9_1139'),
    document.querySelector('#id_10_1139'),
    document.querySelector('.gdpr-wrap  a'),
    document.querySelector('#form_id-1139-yes-signup-formemail-signup'),
    document.querySelector('.form-module__submit button')
  ];


  formElements.forEach((el) => {
    if (el) {
      el.setAttribute('tabindex', '-1');
    }
  });
});



